import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';
import Swal, { escaparHtml } from '../../shared/utils/swal.util';
import { HANDLE_HTTP_ERROR_LOCALLY } from '../http/http-context-tokens';

const MENSAGENS_POR_STATUS: Record<number, string> = {
  0: 'Não foi possível conectar ao servidor.',
  401: 'Sua sessão expirou. Entre novamente.',
  403: 'Você não tem permissão para executar esta ação.',
  404: 'O recurso solicitado não foi encontrado.',
  500: 'Ocorreu um erro interno no servidor.'
};

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.authService.logout();
        }

        if (!request.context.get(HANDLE_HTTP_ERROR_LOCALLY)) {
          Swal.close();

          const apiMessage = error.error?.message
            || error.error?.title
            || MENSAGENS_POR_STATUS[error.status]
            || 'Erro desconhecido';
          const erros = error.error?.errors;
          const listaErros = Array.isArray(erros)
            ? erros.join('\n')
            : typeof erros === 'string' ? erros : '';

          Swal.fire({
            icon: 'error',
            title: `Erro: ${error.status}`,
            html: `<p>${escaparHtml(String(apiMessage))}</p><pre>${escaparHtml(listaErros)}</pre>`,
          });
        }

        return throwError(() => error);
      })
    );
  }
}
